import * as tslib_1 from "tslib";
import { Emitter } from "../util/Emitter";
var BaseContext = /** @class */ (function (_super) {
    tslib_1.__extends(BaseContext, _super);
    function BaseContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOffline = false;
        return _this;
    }
    return BaseContext;
}(Emitter));
export { BaseContext };
//# sourceMappingURL=BaseContext.js.map